"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgVolumeMuteFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M6 16l4.537 3.927c.417.138.764.118 1.041-.058.278-.176.419-.476.422-.9l.004-13.679c.017-.576-.124-.953-.422-1.13-.298-.177-.645-.207-1.04-.09L6.003 8h-2c-1.333.006-2 .673-2 2 0 1.765-.004 3.448-.004 4.013 0 1.325.667 1.991 2 2L6 16zm9.351-.35l2.243-2.243 2.242 2.243c.464.48.935.48 1.415 0s.48-.95 0-1.414l-2.243-2.243L21.25 9.75c.471-.47.471-.942 0-1.414-.472-.47-.943-.47-1.415 0l-2.242 2.243-2.243-2.243c-.46-.482-.932-.482-1.414 0-.482.482-.482.954 0 1.414l2.242 2.243-2.242 2.243c-.472.47-.472.942 0 1.414s.943.472 1.414 0h.001z' }))); };
exports.default = SvgVolumeMuteFilled;
//# sourceMappingURL=VolumeMuteFilled.js.map